import validate from "/builds/void-zero/clients/mijn-epd/node_modules/.pnpm/nuxt@3.17.2_@parcel+watcher@2.5.1_@types+node@22.15.16_db0@0.3.2_eslint@9.26.0_jiti@2.4_c5ce664d060fbe5735a78455e2c10bdf/node_modules/nuxt/dist/pages/runtime/validate.js";
import refresh_45session_45global from "/builds/void-zero/clients/mijn-epd/app/middleware/refresh-session.global.ts";
import manifest_45route_45rule from "/builds/void-zero/clients/mijn-epd/node_modules/.pnpm/nuxt@3.17.2_@parcel+watcher@2.5.1_@types+node@22.15.16_db0@0.3.2_eslint@9.26.0_jiti@2.4_c5ce664d060fbe5735a78455e2c10bdf/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  refresh_45session_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  auth: () => import("/builds/void-zero/clients/mijn-epd/app/middleware/auth.ts")
}